import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="select-city"
export default class extends Controller {
  static targets = ["input"];

  handle({ params }) {
    this.inputTarget.value = params.city;
  }
}
